( function () {
	'use strict';

	function CreateNewTemplateModal ( logger, $modalInstance, templateservice, $scope, ERROR_MSGS ) {
		var self        = this;
		var credentials = templateservice.credentialHandler();

		self.model = angular.copy( templateservice.load( [] ) );

		/**
		 * Trims leading and trailing spaces for template name
		 */
		function trimTemplateName () {
			self.model.template.name = self.model.template.name.trim();
		}

		function okModalHandler ( InvalidForm ) {
			if ( !InvalidForm ) {
				templateservice.save( credentials.userId, self.model )
				.then( function ( data ) {
					$modalInstance.close( data );
				} )
				.catch( function ( error ) {
					if ( error.status === 403 ) {
						logger.notifyError( ERROR_MSGS.tplCreationForbidden );
					} else {
						logger.notifyError( ERROR_MSGS.tplCreationError );
					}
				} )
				.finally( function () {
					self.check = false;
				} );

				self.check = true;
			} else {
				logger.notifyError( 'Template name is required.' );
				$scope.$broadcast( 'show-errors-check-validity' );
			}
		}

		function isValidTemplateName () {
			var isValidRegExp    = new RegExp( '[^ ]' );

			self.isValidTemplate = isValidRegExp.test( self.model.template.name );
			$scope.templateNameForm.templateName.$setValidity( 'validTemplateName', self.isValidTemplate );

			return self.isValidTemplate;
		}

		function cancelModal () {
			$modalInstance.dismiss( 'cancel' );
		}

		function getTypes ( type ) {
			return {
				'tagName' : type.ObservationTypeName
			};
		}

		function activate () {
			logger.info( 'Activated Create New Template Modal View' );

			var children = [ 'No Types Available' ];

			self.isDisabled      = true;
			self.isValidTemplate = true;

			templateservice.observationTypes()
			.then( function ( data ) {
				children = data.map( getTypes );
			} )
			.finally( function () {
				self.model.tags.splice( 0, 0, {
					'filterName' : 'Types',
					'children'   : children
				} );

				self.isDisabled = false;
			} );

			templateservice.setMode( 'save' );
		}

		activate();

		self.cancelModal         = cancelModal;
		self.okModal             = okModalHandler;
		self.isValidTemplateName = isValidTemplateName;
		self.trimTemplateName    = trimTemplateName;
	}

	angular
		.module( 'app.templates' )
		.controller( 'CreateNewTemplateModal', CreateNewTemplateModal );

	CreateNewTemplateModal.$inject = [ 'logger', '$modalInstance', 'templateservice', '$scope', 'ERROR_MSGS' ];
} )( );
